import { HistoryMessageSegment } from "types/historyMessageTypes";
import { HistorySegmentType } from "Config/Enum/historySegmentType";
import { formatDateTime } from "../../formatDateTime";
import { HistoryActionType } from "types/historyActionType";

/**
 * Builds formatted message for ACTION INSERT history type
 * Creates segments with bold formatting for key elements
 *
 * Message format:
 * - With SLA: "The Action 'name' was assigned to the 'target' at 'date', with a response deadline of 'sla date'."
 * - Without SLA: "The Action 'name' was assigned to the 'target' at 'date'."
 * - Then: action text (max 3 lines with Show More option)
 */
export class AssignedActionMessageBuilder {
  static build(action: HistoryActionType): HistoryMessageSegment[] {
    const { name, target, eventText, createdAtUTC, delayBeforeFirstActionMinutes, slaDeadlineMinutes } = action;

    // Format assigned date with delay added (delay is in minutes)
    const delayInMs = (delayBeforeFirstActionMinutes || 0) * 60000;
    const assignedDate = new Date(new Date(createdAtUTC).getTime() + delayInMs);
    const assignedDateFormatted = formatDateTime(assignedDate, "dd/MM/yyyy 'at' HH:mm");

    // Calculate SLA deadline if present
    // SLA Deadline = createdAtUTC + delayBeforeFirstActionMinutes + slaDeadlineMinutes
    const totalMinutesDelay = (delayBeforeFirstActionMinutes || 0) + (slaDeadlineMinutes || 0);
    const slaDate = new Date(new Date(createdAtUTC).getTime() + totalMinutesDelay * 60000);
    const slaDateFormatted = formatDateTime(slaDate, "dd/MM/yyyy 'at' HH:mm");

    const segments: HistoryMessageSegment[] = [
      { type: HistorySegmentType.TEXT, content: "The Action " },
      { type: HistorySegmentType.BOLD, content: name },
      { type: HistorySegmentType.TEXT, content: " was assigned to the " },
      { type: HistorySegmentType.BOLD, content: target },
      { type: HistorySegmentType.TEXT, content: " at " },
      { type: HistorySegmentType.BOLD, content: assignedDateFormatted },
    ];

    // Add SLA deadline if it exists
    if (slaDeadlineMinutes && slaDeadlineMinutes > 0) {
      segments.push({ type: HistorySegmentType.TEXT, content: ", with a response deadline of " });
      segments.push({ type: HistorySegmentType.BOLD, content: slaDateFormatted });
    }

    segments.push({ type: HistorySegmentType.TEXT, content: "." });
    segments.push({ type: HistorySegmentType.LINEBREAK });
    segments.push({ type: HistorySegmentType.LINEBREAK });
    segments.push({ type: HistorySegmentType.TEXT, content: eventText });

    return segments;
  }
}
